import React, {useEffect} from "react"
import ProgramVersionSelect from "components/ProgramVersionSelect"

type Props = {
    onProgramVersionIdsChange: (programVersionIds: number[]) => void
    value?: Array<{id: number}> | null
    programId?: number | number[]
    [key: string]: any
}

export function ProgramVersionFilterSelect({onProgramVersionIdsChange, value, ...props}: Props) {
    useEffect(() => {
        const ids = (value || []).map((version) => version.id).filter(Boolean)
        onProgramVersionIdsChange(ids)
    }, [value, onProgramVersionIdsChange])

    useEffect(() => {
        return () => onProgramVersionIdsChange([])
    }, [onProgramVersionIdsChange])

    return <ProgramVersionSelect isMulti programId={props.programId} value={value} {...props} />
}
